import React from 'react'

import Terms, { TermsProps } from 'components/Terms'

const Policy = ({ pageContext }: TermsProps) => (
  <Terms pageContext={pageContext} />
)

export default Policy
